import React, { Fragment, useEffect } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom'
import '@/utils/i18n';
import Header from '@/layouts/header'
import Footer from "@/components/Footer/index.js";
import { useTranslation } from 'react-i18next';
import RouteComponent from './route'
import { isMobile } from './utils/utils';
function App() {
  const { t, i18n } = useTranslation();
  useEffect(()=>{
    let lsLocal = localStorage.getItem('blur-website-locale');
    if ( !!lsLocal && lsLocal ) {
      i18n.changeLanguage(lsLocal)
    } else {
      i18n.changeLanguage('zh')
      localStorage.setItem('blur-website-locale', 'zh');
    }
  },[])
  return (
    <Fragment>
      <HashRouter>
        <Header/>
        <div style={{ marginTop: isMobile() ? 50 : 80 }}>
          <Switch>
            <Route path="/" component={RouteComponent}></Route>
          </Switch>
        </div>
        <Footer />
      </HashRouter>
    </Fragment>
  );
}
export default App;
